import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { setLicense } from "../../../functions/userIdentity/setLicense";
import { getExpiryCountdown } from "../Firebase/getExpiryCountdownAction";
import signOut from "../../../functions/userIdentity/signOut";
import { Capacitor } from "@capacitor/core";
import { getItem } from "../../../utils/storageHelper";

// Action Types
export const FIREBASE_LICENSE_SUCCESS = "FIREBASE_LICENSE_SUCCESS";
export const FIREBASE_LICENSE_ERROR = "FIREBASE_LICENSE_ERROR";
export const LICENSE_CHECKED = "LICENSE_CHECKED";
export const LICENSE_CHECKING = "LICENSE_CHECKING";

// Thunk Action Creator
export const getFirebaseLicenseFile = createAsyncThunk(
    "api/Licence/checkLicense",
    async (_, { dispatch }) => {
        try {
            const response = await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Licence/checkLicense`,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data === true) {
                // CRITICAL: Save license to storage FIRST, then dispatch actions
                // This ensures the license is available when modal checks run
                await setLicense("true");
                dispatch({ type: FIREBASE_LICENSE_SUCCESS, payload: response.data });
                dispatch(getExpiryCountdown());
            } else {
                // Backend returned false - but this could be a server error, not license revocation
                // Only sign out if this is a genuine authentication error (401/403)
                await setLicense("false");
                dispatch({ type: FIREBASE_LICENSE_ERROR, payload: response.data });
            }
            
            // Mark as checked AFTER license is saved to storage
            dispatch({ type: LICENSE_CHECKED, payload: true });
        } catch (error) {
            const license = await getItem("license");
            const statusCode = error.response?.status;
            
            // Only sign out on genuine authentication/authorization errors
            if ((statusCode === 401 || statusCode === 403) && license === "true") {
                console.error('License check returned auth error - signing out');
                await signOut();
            } else {
                // Server errors (500, 502, 503, 504) or network errors should NOT trigger signout
                console.error('License check failed but will NOT sign out:', {
                    status: statusCode || 'no response',
                    hadLicense: license === "true",
                    error: error.message
                });
            }
            
            dispatch({ type: FIREBASE_LICENSE_ERROR, payload: error.response?.data });
            
            // Mark as checked even if error occurred (AFTER handling error)
            dispatch({ type: LICENSE_CHECKED, payload: true });
        }
    }
);
